import { isVisibleByPath } from "@components/smart/FieldInfo";
import { ISmartFieldBlur, ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { createPath, IEntity } from "@odata/BindingContext";
import { BankAccountEntity, PrDeductionEntity } from "@odata/GeneratedEntityTypes";
import { DocumentTypeCode } from "@odata/GeneratedEnums";
import {
    getBankBlurArgs,
    handleBankFieldChangeWithoutSavedAccount,
    prepareSavedAccounts,
    SAVED_ACCOUNTS_PATH
} from "@pages/banks/bankAccounts/BankAccounts.utils";
import { handleBankAccountOrIBANBlur } from "@utils/BankUtils";

import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import DialogFormView, { IDialogFormViewProps } from "../../../views/formView/DialogFormView";
import { IFormStorageSaveResult, ISaveArgs } from "../../../views/formView/FormStorage";

class DepositClosingFormView extends DialogFormView<IEntity> {

    constructor(props: IDialogFormViewProps<IEntity>) {
        super(props);
        this.save = this.save.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    onAfterLoad(): Promise<void> {
        const { storage } = this.props;

        prepareSavedAccounts({
            storage,
            type: DocumentTypeCode.InvoiceReceived,
            businessPartner: this.entity.Recipient?.BusinessPartner ?? {},
            businessPartnerPath: PrDeductionEntity.Recipient,
            account: this.entity.BankAccount,
            isInit: true
        });

        if (!this.entity.BankAccount.Country?.Code) {
            storage.setDefaultValueByPath(createPath(PrDeductionEntity.BankAccount, BankAccountEntity.Country));
        }

        return super.onAfterLoad();
    }

    handleBlur(args: ISmartFieldBlur): Promise<void> {
        if (args.wasChanged) {
            handleBankAccountOrIBANBlur(getBankBlurArgs(this.props.storage.getThis(), args.bindingContext));
        }
        return super.handleBlur(args);
    }

    handleChange(e: ISmartFieldChange): void {
        const { storage } = this.props;
        handleBankFieldChangeWithoutSavedAccount({ storage }, e);
        super.handleChange(e);
    }

    onBeforeSave(data?: IEntity): IEntity {
        data = super.onBeforeSave(data) ?? data ?? this.entity;

        if (!isVisibleByPath(this.props.storage, SAVED_ACCOUNTS_PATH)) {
            data.BankAccount = null;
        }

        return data;
    }

    async save(saveArgs?: Partial<ISaveArgs>): Promise<IFormStorageSaveResult> {
        return super.save({
            ...saveArgs,
            successSubtitle: null, // no success message, will be direcly closed
            skipLoad: true
        });
    }
}

export default withPermissionContext(DepositClosingFormView);